import PinForm from './PinForm';

export default PinForm;
